import DataStore from './DataStore.js';
import Api from './api.js';

const dataStore = new DataStore();

class DataManager {
    fetchUser(success, error) {
        success = success || ((user) => {});
        error = error || ((err) => {});
        var user = dataStore.getUser();
        if (user) {
            Api.firebaseAuth(user.token);
            success(user);
        }

        //KBM - We should refresh the user every time, in case their membership status changed.
        //So, we'll need to check that here once we get to that QA
        Api.auth((user) => {
            Api.firebaseAuth(user.token, (error) => {
                console.log("auth error: %o", error);
            });
            dataStore.saveUser(user);
            success(user);
        }, (err) => {
            //Kick the user out to the locator if we get an error
            dataStore.clearUser();
            error(err)
        });
    }

}

export default DataManager;



// WEBPACK FOOTER //
// ./src/api/DataManager.js